<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container" v-if="this.mentorships !== null">
        <div class="element">
          <div class="search-box-container">
            <div class="nav">
              <div>
                <h1>{{ title }}</h1>
                <p>Trilhe sua jornada com suporte e orientação de especialistas</p>
              </div>
              <div class="search-box">
                <input
                  type="text"
                  id="searchMentorshipInput"
                  placeholder="Buscar mentorias"
                  @input="debounceSearch"
                  :class="{ disabled: searching || loadingMore }"
                  :disabled="searching || loadingMore"
                />
                <button
                  type="submit"
                  @click="searchCourseMentorships()"
                  :class="{ disabled: searching || loadingMore }"
                  :disabled="searching || loadingMore"
                >
                  <i class="fa fa-search icons"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="talent-page" v-if="searching">
            <div
              class="loading_container"
              style="height: auto; margin-top: 30px; overflow: hidden"
            >
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only"></span>
              </div>
            </div>
          </div>
          <div class="talent-page" v-else-if="searchError">
            <p class="mt-3 text-center text-danger" style="font-weight: bold">
              Ocorreu um erro ao buscar mentorias.<br />
              Por favor, atualize a página e tente novamente.
            </p>
          </div>

          <div class="talent-page" v-else-if="mentorships && mentorships.length === 0">
            <p class="mt-3 text-center" style="font-weight: bold" v-if="hasKeywords">
              Nenhuma mentoria encontrada. Tente buscar com outros termos.
            </p>
            <p class="mt-3 text-center" style="font-weight: bold" v-else>
              Nenhuma mentoria disponível ainda. Volte em breve.
            </p>
          </div>
          <div class="talent-page mt-3" v-else>
            <div
              class="mt-3 text-muted"
              style="font-weight: bold"
              v-if="allMentorshipGrid.length === 1 && allMentorshipGrid[0].length === 0"
            >
              Nenhum mentoria disponível ainda. Volte mais tarde.
            </div>
            <div class="video_class">
              <!-- <div class="alert alert-info mt-3 mb-0">Novos cursos disponíveis!</div> -->
              <div class="row gy-3 mt-0" v-for="grid in allMentorshipGrid">
                <div
                  class="col-md-6 col-lg-4 course"
                  v-for="mentorship in grid"
                  :key="mentorship.id"
                  :id="mentorship.id"
                >
                  <a :href="mentorshipLink(mentorship)">
                    <div class="card">
                      <div class="video_img_container">
                        <img
                          class="video_img"
                          :src="getMentorshipThumbnailURL(mentorship)"
                          alt=""
                        />
                      </div>
                      <div class="card-body">
                        <h4>{{ mentorship.title }}</h4>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="page_number">
              <button
                id="fetchMoreVideos"
                class="btn see_more btn-small"
                :class="{ disabled: loadingMore }"
                @click="fetchMore()"
                v-if="hasMore"
              >
                {{ loadingMore ? "Carregando..." : "Mostrar mais" }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="center-block" v-else>
        <div>
          <div class="alert alert-danger mb-0 text-center">
            Mentorias não disponíveis para este curso.
            <p class="text-center">
              <a href="/mentorias" class="btn mt-2">
                <i class="fa fa-arrow-left" /> Voltar para as mentorias</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

const RESULT_COUNT = 10;

import debounce from "lodash.debounce";

const debouncedHandler = debounce((event, func) => {
  func(event.target.value);
}, 500);

export default {
  components: { SideBar, TopBar },

  beforeUnmount() {
    debouncedHandler.cancel();
  },

  created() {
    this.$store.commit("setActiveSection", "CourseMentorshipListPage");
    this.loadMentorships();
  },

  data() {
    return {
      searching: false,
      profile: null,
      mentorships: [],
      hasKeywords: false,
      searchError: false,
      loadingMore: false,
      hasMore: true,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    title() {
      let title = "Mentorias";
      switch (this.$route.params.courseId) {
        case "form-av":
          title += ": Formação em Assistência Virtual";
          break;
        case "form-ap":
          title += ": Formação AExpert";
          break;
      }
      return title;
    },
    allMentorshipGrid() {
      var newArr = [];
      if (this.mentorships) {
        newArr.push(this.mentorships.slice(0));
      }
      return newArr;
    },
  },

  methods: {
    async loadMentorships() {
      this.$store.commit("setLoading", true);
      try {
        let response = await AssistantManager.searchMentorships(
          this.$route.params.courseId,
          null,
          true,
          null,
          RESULT_COUNT
        );
        this.mentorships = response.mentorships;
        this.profile = response.profile;
        if(this.profile.open_offer) {
          this.showOfferModal(this.profile.open_offer);
        }
        
        this.$store.commit("setActiveUser", response.profile);
        this.$store.commit("setLoading", false);
        this.hasMore = this.mentorships && this.mentorships.length >= RESULT_COUNT;
      } catch (error) {
        this.handleAPIError(error, this.$route.fullPath.replace(/^\/+/, ""));
      }
    },

    debounceSearch(e) {
      debouncedHandler(e, () => {
        this.searchMentorships();
      });
    },

    async searchMentorships() {
      let ctx = this;
      ctx.searching = true;
      ctx.searchError = false;
      try {
        let response = await AssistantManager.searchMentorships(
          this.$route.params.courseId,
          $("#searchMentorshipInput").val(),
          false,
          null,
          RESULT_COUNT
        );

        this.mentorships = response.mentorships;
        if (response.mentorships === null) {
          return;
        }
        this.hasMore = response.mentorships.length >= RESULT_COUNT;
        this.hasKeywords = !StringUtils.isEmpty($("#searchMentorshipInput").val());
      } catch (err) {
        console.log(err);
        ctx.searchError = true;
      } finally {
        ctx.searching = false;
        ctx.$nextTick(() => {
          $("#searchMentorshipInput").focus();
          ctx.applyTruncation();
        });
      }
    },

    async fetchMore() {
      let ctx = this;
      ctx.loadingMore = true;
      ctx.searchError = false;
      let lastCourse = null;
      if (this.mentorships && this.mentorships.length > 0) {
        lastCourse = this.mentorships[this.mentorships.length - 1];
      }
      try {
        let response = await AssistantManager.searchMentorships(
          this.$route.params.courseId,
          $("#searchMentorshipInput").val(),
          false,
          lastCourse,
          RESULT_COUNT
        );

        this.mentorships = this.mentorships.concat(response.mentorships);
        if (response.mentorships.length < RESULT_COUNT) {
          this.hasMore = false;
        }

        ctx.$nextTick(() => {
          ctx.applyTruncation(() => {
            if (response.mentorships.length > 0) {
              let card = $(".talent-page")
                .find("#" + response.mentorships[0].id)
                .get(0);
              let navBar = $(".body-container .element .nav").get(0);
              let scrollDiv = card.offsetTop - navBar.offsetHeight - 116;
              window.scrollTo({ top: scrollDiv, behavior: "smooth" });
            }
          });
        });
      } catch (err) {
        console.log(err);
      } finally {
        ctx.loadingMore = false;
      }
    },

    mentorshipLink(mentorship) {
      return "/mentoria/" + mentorship.id;
    },
  },
};
</script>
